import classNames, { Value as ClassValue } from "classnames";
import React, { CSSProperties } from "react";

export function TableHeading(props: {
  className?: ClassValue;
  children: React.ReactNode;
}) {
  return (
    <th
      className={classNames("has-background-color-primary", props.className)}
      style={{ color: "white" }}
    >
      {props.children}
    </th>
  );
}

export const tableClassNames =
  "table is-fullwidth is-hoverable is-striped vertically-centered";

export function getAltRowStyle(index: number): CSSProperties {
  if (index % 2 === 0) {
    return {};
  } else {
    return { backgroundColor: "#cbe6ff" };
  }
}
